import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';

import { DxSelectBoxModule } from 'devextreme-angular';
import { Vm } from '../../state/integration-tester.models';

@Component({
  selector: 'it-context-bar',
  standalone: true,
  templateUrl: './it-context-bar.component.html',
  styleUrls: ['./it-context-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, DxSelectBoxModule],
})
export class ItContextBarComponent {
  @Input({ required: true }) vm!: Vm;

  @Output() integrationChanged = new EventEmitter<number | null>();
  @Output() loginChanged = new EventEmitter<number | null>();
  @Output() testLogin = new EventEmitter<void>();

  onIntegrationChanged(e: any): void {
    const id = Number(e?.value);
    this.integrationChanged.emit(Number.isFinite(id) && id > 0 ? id : null);
  }

  onLoginChanged(e: any): void {
    const id = Number(e?.value);
    this.loginChanged.emit(Number.isFinite(id) && id > 0 ? id : null);
  }
}
